// src/shared/ui/icon/icon.tsx
import { useEffect, useState } from "react";

// src/shared/assets/icons.ts
var iconPaths = {
  "angle-left": "/assets/icons/angle-left.svg",
  "angle-right": "/assets/icons/angle-right.svg",
  "arrow-back": "/assets/icons/arrow-back.svg",
  "arrow-left": "/assets/icons/arrow-left.svg",
  "arrow-right-to-bracket": "/assets/icons/arrow-right-to-bracket.svg",
  "arrow-up-outline": "/assets/icons/arrow-up-outline.svg",
  "bell-outline": "/assets/icons/bell-outline.svg",
  "calendar-month": "/assets/icons/calendar-month.svg",
  "cash-outline": "/assets/icons/cash-outline.svg",
  check: "/assets/icons/check.svg",
  "check-circle": "/assets/icons/check-circle.svg",
  "chevron-down": "/assets/icons/chevron-down.svg",
  "chevron-right": "/assets/icons/chevron-right.svg",
  "chevron-sort": "/assets/icons/chevron-sort.svg",
  "clipboard-list-outline": "/assets/icons/clipboard-list-outline.svg",
  "clock-outline": "/assets/icons/clock-outline.svg",
  "cog-outline": "/assets/icons/cog-outline.svg",
  "copy-outline": "/assets/icons/copy-outline.svg",
  "dots-horizontal-outline": "/assets/icons/dots-horizontal-outline.svg",
  "download-outline": "/assets/icons/download-outline.svg",
  "edit-outline": "/assets/icons/edit-outline.svg",
  exclamation: "/assets/icons/exclamation.svg",
  eye: "/assets/icons/eye.svg",
  "eye-slash-outline": "/assets/icons/eye-slash-outline.svg",
  factory: "/assets/icons/factory.svg",
  file: "/assets/icons/file.svg",
  "file-image": "/assets/icons/file-image.svg",
  "file-lines-outline": "/assets/icons/file-lines-outline.svg",
  "freepik-arrows-inject-2": "/assets/icons/freepik-arrows-inject-2.svg",
  "freepik-background-simple-inject-2": "/assets/icons/freepik-background-simple-inject-2.svg",
  "freepik-background-simple-inject-2-1": "/assets/icons/freepik-background-simple-inject-2-1.svg",
  "freepik-contract-inject-2": "/assets/icons/freepik-contract-inject-2.svg",
  "freepik-device-1-inject-2": "/assets/icons/freepik-device-1-inject-2.svg",
  "freepik-device-2-inject-2": "/assets/icons/freepik-device-2-inject-2.svg",
  "freepik-graphics-inject-2": "/assets/icons/freepik-graphics-inject-2.svg",
  "freepik-graphics-inject-2-1": "/assets/icons/freepik-graphics-inject-2-1.svg",
  "freepik-left-hand-inject-2": "/assets/icons/freepik-left-hand-inject-2.svg",
  "freepik-plants-inject-2": "/assets/icons/freepik-plants-inject-2.svg",
  "freepik-right-hand-inject-2": "/assets/icons/freepik-right-hand-inject-2.svg",
  "home-outline": "/assets/icons/home-outline.svg",
  "info-outline": "/assets/icons/info-outline.svg",
  "lock-outline": "/assets/icons/lock-outline.svg",
  "message-dots-outline": "/assets/icons/message-dots-outline.svg",
  "plus-outline": "/assets/icons/plus-outline.svg",
  "question-mark-outline": "/assets/icons/question-mark-outline.svg",
  "ruble-sign": "/assets/icons/ruble-sign.svg",
  "search-outline": "/assets/icons/search-outline.svg",
  "unlock-outline": "/assets/icons/unlock-outline.svg",
  "upload-outline": "/assets/icons/upload-outline.svg",
  "user-circle-outline": "/assets/icons/user-circle-outline.svg",
  "x-outline": "/assets/icons/x-outline.svg",
  zip: "/assets/icons/zip.svg"
};

// src/shared/assets/images.ts
var imagePaths = {
  "400-error-bad-request": "/assets/images/400-error-bad-request.svg",
  "401-error-unauthorized": "/assets/images/401-error-unauthorized.svg",
  "403-error-forbidden": "/assets/images/403-error-forbidden.svg",
  "404-error-with-a-landscape": "/assets/images/404-error-with-a-landscape.svg",
  "500-internal-server-error": "/assets/images/500-internal-server-error.svg",
  acces: "/assets/images/acces.svg",
  "app-monetization": "/assets/images/app-monetization.svg",
  "application-end": "/assets/images/application-end.svg",
  "application-succes": "/assets/images/application-succes.svg",
  "choice-chat": "/assets/images/choice-chat.svg",
  close: "/assets/images/close.svg",
  "cyber-attack": "/assets/images/cyber-attack.svg",
  documents: "/assets/images/documents.svg",
  "dont-work": "/assets/images/dont-work.svg",
  fly: "/assets/images/fly.svg",
  "folder-bro": "/assets/images/folder-bro.svg",
  "forgot-password-bro-3": "/assets/images/forgot-password-bro-3.svg",
  mailbox: "/assets/images/mailbox.svg",
  money: "/assets/images/money.svg",
  "new-chat": "/assets/images/new-chat.svg",
  pdf: "/assets/images/pdf.svg",
  profiling: "/assets/images/profiling.svg",
  "resume-folder": "/assets/images/resume-folder.svg",
  "search-engines": "/assets/images/search-engines.svg",
  "select-provider": "/assets/images/select-provider.svg",
  "signing-a-contract": "/assets/images/signing-a-contract.svg",
  spinner: "/assets/images/spinner.svg",
  succes: "/assets/images/succes.svg",
  table: "/assets/images/table.svg",
  "team-checklist-bro": "/assets/images/team-checklist-bro.svg",
  "version-control": "/assets/images/version-control.svg"
};

// src/shared/ui/icon/icon.tsx
import { jsx } from "react/jsx-runtime";
var Icon = ({
  name,
  size = 20,
  color,
  className = "",
  alt,
  loading = "lazy"
}) => {
  const [svgContent, setSvgContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const loadSvg = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(iconPaths[name]);
        if (!response.ok) {
          throw new Error(`Failed to load icon: ${name}`);
        }
        const text = await response.text();
        let processedSvg = text;
        if (color) {
          processedSvg = text.replace(/fill="#[^"]*"/g, `fill="${color}"`).replace(/fill='#[^']*'/g, `fill="${color}"`).replace(/stroke='#[^']*'/g, `stroke="${color}"`).replace(/fill="currentColor"/g, `fill="${color}"`).replace(/fill='currentColor'/g, `fill="${color}"`).replace(/stroke='currentColor'/g, `stroke="${color}"`);
        } else {
          processedSvg = text.replace(/fill="#[^"]*"/g, 'fill="currentColor"').replace(/fill='#[^']*'/g, 'fill="currentColor"').replace(/stroke="#[^"]*"/g, 'stroke="currentColor"');
        }
        setSvgContent(processedSvg);
      } catch (error) {
        console.error(`Failed to load icon: ${name}`, error);
      } finally {
        setIsLoading(false);
      }
    };
    loadSvg();
  }, [name, color]);
  if (isLoading || !svgContent) {
    return /* @__PURE__ */ jsx(
      "span",
      {
        className: `inline-flex items-center justify-center ${className}`,
        style: {
          width: typeof size === "number" ? `${size}px` : size,
          height: typeof size === "number" ? `${size}px` : size
        },
        "aria-label": alt || name,
        role: "img"
      }
    );
  }
  const sizeValue = typeof size === "number" ? `${size}px` : size;
  const finalColor = color || "currentColor";
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: `inline-flex items-center justify-center ${className}`,
      style: {
        width: sizeValue,
        height: sizeValue,
        color: finalColor === "currentColor" ? void 0 : finalColor
      },
      dangerouslySetInnerHTML: { __html: svgContent },
      "aria-label": alt || name,
      role: "img"
    }
  );
};

// src/shared/ui/image/image.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var Image = ({
  name,
  width,
  height,
  className = "",
  alt,
  loading = "lazy"
}) => {
  const style = {};
  if (width) {
    style.width = typeof width === "number" ? `${width}px` : width;
  }
  if (height) {
    style.height = typeof height === "number" ? `${height}px` : height;
  }
  return /* @__PURE__ */ jsx2(
    "img",
    {
      src: imagePaths[name],
      alt: alt || name,
      className,
      style,
      loading
    }
  );
};
export {
  Icon,
  Image,
  iconPaths,
  imagePaths
};
//# sourceMappingURL=index.js.map